<template>
  <div>
    <PageTitle title="Hacker News: New" />
    <PostList source="https://hacker-news.firebaseio.com/v0/newstories.json"/>
  </div>
</template>

<script>
import PostList from '@/components/PostList'
import PageTitle from '@/components/PageTitle'
export default {
  name: 'New',
  components: {
    PageTitle,
    PostList
  }
}
</script>
